import googleAnalytics from './googleAnalytics';
import fbPixel from './fbPixel';
import analytics from './BookingAnalytics';

export { default as Analytics } from './components/Analytics';

// eslint-disable-next-line import/prefer-default-export
export const onRouteUpdate = (store, acceptCookies) => () => {
  const acceptCookie = acceptCookies.getAcceptCookie(store.getState());
  if (acceptCookie) googleAnalytics.logPageView(window.location.pathname);
  fbPixel.trackPageView(['instantExperience', 'ownerPixel']);
  analytics.trackPageview(window.location.pathname);
};



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/index.js